/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';

    export interface IFilterDirectiveMap {
        [key: string]: boolean;
    }

    /**
     * Factory callback type
     */
    declare type EurovisionFilterDirectiveFactoryCb = () => EurovisionFilterDirective;

    /**
     * Custom scope
     */
    interface IEurovisionFilteraDirectiveScopeDef {
        stateMap: string;
        onChange: string;
    }

    /**
     * Custom scope
     */
    export interface IEurovisionFilterDirectiveScope extends ng.IScope {
        stateMap: IFilterDirectiveMap;
        onChange: () => void;

        allValue: IFilterDirectiveMap;
        changeValue: (key: string) => void;
        someChecked: boolean;
        stateAsArray: () => string[];
    }

    /**
     * Bar directive
     */
    export class EurovisionFilterDirective implements ng.IDirective {
        public static $name: string = "eurovisionFilter";
        
        public link: (scope: IEurovisionFilterDirectiveScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'AE';
        public transclude: boolean = false;
        public replace: boolean = true;
        public templateUrl: string = 'decorators/eurovision-filter-directive.html';
        public scope: IEurovisionFilteraDirectiveScopeDef = {
            stateMap: '=',
            onChange: '&',
        };

        /**
         * Factory for the directive
         */
        public static Factory(): EurovisionFilterDirectiveFactoryCb {
            let directive: EurovisionFilterDirectiveFactoryCb = () => {
                return new EurovisionFilterDirective();
            };
            return directive;
        }

        /**
         * Constructor
         */
        constructor() {
            EurovisionFilterDirective.prototype.link = ($scope: IEurovisionFilterDirectiveScope, element: JQuery, attrs: ng.IAttributes) => {
                $scope.allValue = {
                    "All": false,
                };

                // TODO avoid calling method from HTML
                $scope.stateAsArray = () => {
                    return $scope.stateMap !== undefined ? this.getSortedKeys($scope.stateMap) : undefined;
                }

                $scope.changeValue = (key: string) => {
                    if (key === 'All') {
                        let all: string = 'All';
                        this.changeStateMapTo($scope.stateMap, $scope.allValue[all]);
                    } else {
                        this.updateAllValue($scope.stateMap, $scope.allValue);
                    }
                    $scope.someChecked = this.someChecked($scope.stateMap);
                    $scope.onChange();
                };
            };
        }

        private getSortedKeys(map: IStateMap) {
            return Common.Utils.sortStrings(Object.keys(map));
        }

        private someChecked(stateMap: IFilterDirectiveMap): boolean {
            return Object.keys(stateMap).some((state: string) => {
                return stateMap[state];
            });
            
        }

        private updateAllValue(stateMap: IFilterDirectiveMap, allValue: IFilterDirectiveMap): void {
            let allString: string = 'All';
            allValue[allString] = Object.keys(stateMap).every((value: string) => {
                return stateMap[value];
            });
        }

        private changeStateMapTo(stateMap: IFilterDirectiveMap, newState: boolean): void {
            Object.keys(stateMap).forEach((value: string) => {
                stateMap[value] = newState;
            });
        }
    }
}
